module.exports = __webpack_public_path__ + "img/alert.a6f93125.svg";